import { useBreakpointValue } from "@gluestack-style/react";
import { IModalRefProps as IModalRefPropsModal } from "@repo/core/components/layout/Modal/types";
import { IModalRefProps } from "@repo/core/components/layout/Drawer/types";
import { IModalTemplateType } from "@repo/core/components/layout/ModalTemplate/types";
import { IMenuItem } from "@repo/core/components/layout/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useAuthStore } from "@repo/core/stores/auth";
import {
  ViewableContent,
  useViewedContentStore
} from "@repo/core/stores/viewedContent";
import { useRef } from "react";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";

export const useAuthLayoutController = () => {
  const { user, logout } = useAuthStore();
  const { setShowCorrectStoreAlert } = useStoresAndShopkeepersStore();
  const modalRef = useRef<IModalRefPropsModal | null>(null);
  const { hasViewedContent } = useViewedContentStore();
  const hasViewedWelcomePage = hasViewedContent(
    ViewableContent.APP_WELCOME,
    user?.username || ""
  );
  const { push, replace } = useNavigation();
  const mobileDrawerRef = useRef<IModalRefProps>();

  const isMobile = useBreakpointValue({
    base: true,
    md: false
  });

  const handleMenuItem = (item: IMenuItem) => {
    switch (item.action) {
      case "$custom":
        handleCustomItem(item);
        break;
      default:
        push(item.key as never);
        mobileDrawerRef?.current?.close();
        break;
    }
  };

  const handleCustomItem = (item: IMenuItem) => {
    switch (item.key) {
      case "log-out":
        modalRef.current?.open();
        break;
      case "open-menu":
        mobileDrawerRef?.current?.open();
        break;
      default:
        console.error("Unrecognized custom action");
        break;
    }
  };

  const modalOptions = [
    {
      label: "Cancelar",
      type: IModalTemplateType.outline,
      onPress: () => {
        modalRef.current?.close();
      }
    },
    {
      label: "Sair",
      type: IModalTemplateType.danger,
      onPress: () => {
        logout();
        replace("/");
        setShowCorrectStoreAlert(true);
      }
    }
  ];

  return {
    isMobile,
    handleMenuItem,
    mobileDrawerRef,
    hasViewedWelcomePage,
    user,
    modalOptions,
    modalRef
  };
};
